export const sortBy = <T>(sortValueFn: (item: T) => any) => {
  return (a: T, b: T): number => {
    const aValue = sortValueFn(a);
    const bValue = sortValueFn(b);
    if (aValue < bValue) return -1;
    else if (aValue > bValue) return 1;
    else return 0;
  };
};

export const sortByAdditional = <T>(
  sortValueFn: (item: T) => any,
  sortFn: (a: T, b: T) => number
) => {
  return (a: T, b: T): number => {
    const result = sortFn(a, b);
    if (result !== 0) return result;
    return sortBy(sortValueFn)(a, b);
  };
};

export const reversed = <T>(sortValueFn: (a: T, b: T) => any) => {
  return (a: T, b: T): number => {
    return sortValueFn(b, a);
  };
};
